import { createContext, useContext, useState } from 'react'

import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

import { PublicConfig } from 'src/config/env'

interface AppConfigArgs {
  config: PublicConfig
  children: React.ReactNode
}
const AppConfigContext = createContext<PublicConfig>({} as PublicConfig)

export const useAppConfig = (): PublicConfig => {
  return useContext(AppConfigContext)
}

export type UseAppBrandConfigReturn =
  | PublicConfig['hoseasons']
  | PublicConfig['cottages.com']

export const useAppBrandConfig = (brand: Brand): UseAppBrandConfigReturn => {
  const appConfig = useContext(AppConfigContext)

  if (brand === 'hoseasons' || brand === 'cottages.com') {
    return appConfig[brand]
  }

  const emptyBrandConfig = {
    useLegacyDestinationSelector: false,
  }

  return emptyBrandConfig
}

export const AppConfigProvider = ({
  config,
  children,
}: AppConfigArgs): JSX.Element => {
  const [appConfig] = useState<PublicConfig>(config)

  return (
    <AppConfigContext.Provider value={appConfig}>
      {children}
    </AppConfigContext.Provider>
  )
}
